<template>
  <section id="deluxe-vehicle-filter">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/ion-rangeslider/2.3.1/css/ion.rangeSlider.min.css"/>
    <div class="background-row" :style="{backgroundImage: bgPhoto}"></div>
    <div class="background-image-overlay">
      <div class="overlay-content">
        <video v-if="images.videoLink.length > 0" autoplay="true" class="hidden-xs" id="homepage-background-video" loop="true" muted="true">
          <source
            class="ajax-video"
            :src="images.videoLink"
            type="video/mp4"
          />
        </video>
        <div class="container">
          <div class="filter-content">
            <div class="row">
              <div class="col-md-4 side-search-form vehicle-browse-ajax search-section">
                <form action="" class="vehicle-search-form" method="get">
                  <input class="inventory-type set-on-load" name="new" type="hidden" value="true" />
                  <h3 class="text-center section-header">
                    <i class="fa fa-car">
                    </i><span>&nbsp;Find Your Vehicle&nbsp;</span>
                    <i class="fa fa-car">
                    </i>
                  </h3>
                  <div class="browse-buttons">
                    <button class="btn inventory-type-button-block search-inv-type new-side-search track-click" data="true" data-category="Home Page Actions" type="button">New</button>
                    <button class="btn inventory-type-button-block search-inv-type used-side-search track-click" data="false" data-category="Home Page Actions" type="button">Used</button>
                  </div>
                  <div class="form-group">
                    <select class="form-control vehicle-search vehicle-search-make" name="make">
                      <option value="default">{{brandName}}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select class="form-control vehicle-search vehicle-search-model" name="model">
                      <option value="default">Model</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select class="form-control vehicle-search vehicle-search-trim" name="trim">
                      <option value="default">Trim</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <input class="vehicle-search-submit btn btn-block find-my-car-button" type="submit" value="Find My Car!" />
                  </div>
                </form>
              </div>
              <hr class="mobile-hr" />
              <div class="col-md-4 price-range-search search-section hidden-sm hidden-xs">
                <h3 class="text-center section-header">
                  <i class="fa fa-money">
                  </i><span>&nbsp;Choose Your Budget&nbsp;</span>
                  <i class="fa fa-money">
                  </i>
                </h3>
                <div class="price-range">
                  <input type="text" class="js-range-slider" id="price-range-slider-wb" value="" />
                </div>
                <h4 class="vehicles-available text-center">
                  <span>Vehicles Available:&nbsp;</span>
                  <span class="vehicle-count">
                    215
                  </span><span class="loading">
                  </span></h4>
                <a class="btn inventory-type-button-block price-range-btn" href="#">View Vehicles</a>
              </div>
              <div class="col-md-4 search-section browse-site">
                <h3 class="text-center section-header">
                  <i class="fa fa-search-plus">
                  </i><span>&nbsp;Browse the Site&nbsp;</span>
                  <i class="fa fa-search-plus">
                  </i></h3>
                <div>
                  <a class="track-click event-click btn inventory-type-button-block" data-category="Browse New Vehicles"
                    href="#">
                    Browse New Vehicles
                  </a><a class="track-click event-click btn inventory-type-button-block" href="#">
                    Browse Used Vehicles
                  </a><a class="track-click event-click btn inventory-type-button-block">
                    Schedule Service Appointment
                  </a><a class="track-click event-click btn inventory-type-button-block">
                    Start Finance Application
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import 'ion-rangeslider';

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand !== 'honda') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  },
  mounted() {
    $("#price-range-slider-wb").ionRangeSlider({
      skin: "big",
      type: "double",
      min: 0,
      max: 100000,
      from: 0,
      to: 100000,
      prefix: "$"
    });
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  #deluxe-vehicle-filter {
    position: relative;
  }
  #deluxe-vehicle-filter .overlay-content {
    padding: 6% 0;
    position: relative;
    overflow: hidden;
  }
  #deluxe-vehicle-filter .background-row {
    position: absolute;
    z-index: -1;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    overflow: hidden;
    background-size: cover;
    background-color: #222;
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }
  #deluxe-vehicle-filter video#homepage-background-video {
    position: absolute;
    top: -20%;
    left: 0;
    right: 0;
    width: auto;
    min-height: 120%;
    min-width: 100%;
    height: auto;
    z-index: -1;
    background-size: cover;
  }
  #deluxe-vehicle-filter .filter-content {
    background: rgba(0,0,0,.4);
    padding: 20px;
    color: #fff;
  }
  #deluxe-vehicle-filter .vehicles-available {
    font-size: 1.2em;
    margin: 55px 0;
  }
  #deluxe-vehicle-filter .price-range {
    border: 1px solid #428bca;
    padding: 5px 20px 15px 20px;
  }
  #deluxe-vehicle-filter .waitMe_text {
    margin-top: 2px;
  }
  #deluxe-vehicle-filter .section-header {
    color: #fff;
    margin: 10px 0;
    font-size: 20px;
  }
  #deluxe-vehicle-filter .deluxe-filter-used-space-holder {
    margin-bottom: 67px;
  }
  #deluxe-vehicle-filter .mobile-hr {
    border-top: 1px solid #626262;
    padding: 0 15px;
    max-width: 480px;
    margin: 30px auto;
  }
  #deluxe-vehicle-filter .search-section {
    max-width: 480px;
    margin: 0 auto;
  }
  #deluxe-vehicle-filter .browse-site .inventory-type-button-block {
    margin-bottom: 12px;
  }
  .dg-deluxe-vehicle-filter .form-control.vehicle-search {
    height: 32px;
  }
  #deluxe-vehicle-filter .btn {
    display: block;
    color: #fff;
    background: var(--primary-color);
    font-size: 18px;
    font-weight: 600;
    padding: 10px;
    border-radius: 0;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  #deluxe-vehicle-filter .new-side-search, #deluxe-vehicle-filter .vehicle-search-submit {
    color: #fff;
    background: var(--secondary-color);
  }
  #deluxe-vehicle-filter .btn:hover {
    background: var(--primary-dark);
  }
  #deluxe-vehicle-filter button.btn {
    width: calc(50% - 5px);
    margin-bottom: 15px;
  }
  #deluxe-vehicle-filter .browse-buttons {
    display: flex;
    justify-content: space-between;
  }

  @media only screen and (min-width: 1200px) {
    #deluxe-vehicle-filter .container {
      max-width: 1185px;
    }
  }

  @media (min-width: 992px) {
    #deluxe-vehicle-filter .price-range-search {
      border-left: 1px solid #626262;
      border-right: 1px solid #626262;
      min-height: 320px;
    }
    #deluxe-vehicle-filter .mobile-hr {
      display: none;
      border-top: 1px solid #626262;
    }
    #deluxe-vehicle-filter .section-header {
      color: #fff;
      margin: 10px 0;
      font-size: 24px;
    }
  }

  @media (max-width: 1199px) {
    #deluxe-vehicle-filter .btn {
      font-size: 15px;
      height: 38px;
    }
    #deluxe-vehicle-filter .vehicles-available {
      margin: 39px 0;
    }
  }
</style>